import React from 'react';
import {
    RawPurchaseEntryBase,
    buildRawPurchaseEntryDetailPanelTypes,
    buildRawPurchaseEntryHiddenPanelTypes,
    buildRawPurchaseEntryTotalPanelDefinitions,
    RAW_PURCHASE_ENTRY_FIELD_IDS
} from './RawPurchaseEntryBase';

const detailPanelTypesByMaterialCategory = buildRawPurchaseEntryDetailPanelTypes("110", "120", "130");

const entryConfig = {
    screenId: "RawPurchaseEntryNone",
    apiController: "RawPurchase",
    dataController: "RawPurchase",
    layoutController: "RawPurchase",
    formKey: "RawPurchaseEntryNone",
    listController: "RawPurchase",
    callerIdentifier: "RawPurchase",
    sourceCategoryCode: "",
    primarykeys: ["ZSR_DENNO"],
    sourceCategoryColumnId: RAW_PURCHASE_ENTRY_FIELD_IDS.sourceCategoryCode,
    materialCategoryColumnId: RAW_PURCHASE_ENTRY_FIELD_IDS.materialCategoryCode,
    materialCategoryStateKeys: [
        "materialCategoryCode"
    ],
    detailPanelTypesByMaterialCategory: detailPanelTypesByMaterialCategory,
    hiddenPanelTypesByMaterialCategory: buildRawPurchaseEntryHiddenPanelTypes("110", "120", "130"),
    totalPanelDefinitions: buildRawPurchaseEntryTotalPanelDefinitions("111", "121", "131")
};

export const RawPurchaseEntryNone = React.forwardRef((props, ref) => {
    return <RawPurchaseEntryBase {...props} ref={ref} entryConfig={entryConfig} />;
});
